<script setup lang="ts">
import { computed } from 'vue'
import FilterField from '@/components/atoms/element-filters/FilterField.vue'
import HindranceSeverityMenu from '@/components/atoms/swade/HindranceSeverityMenu.vue'

const severity = defineModel<string[]>('severity', { default: () => [] })
defineProps<{ label?: string; placeholder?: string }>()

// The model carries the sentinel pair ['choice', <type>]; the widget only needs
// the concrete type (index 1), or null when nothing is selected.
const selectedType = computed<string | null>(() => severity.value[1] ?? null)

// Preserve the existing sentinel: ['choice', <type>] returns hindrances of the
// chosen severity OR player's-choice severity. Do not "simplify" to [type].
const onChange = (event: any): void => {
  if (!event?.value?.type) { severity.value = []; return }
  severity.value = ['choice', event.value.type]
}
</script>

<template>
  <FilterField :label="label">
    <HindranceSeverityMenu :placeholder="placeholder" :selected="selectedType" @severity-selected="onChange" />
  </FilterField>
</template>
